/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Query } from 'react-apollo';
import {
    object, string, bool, func, shape, arrayOf, number,
} from 'prop-types';
import { format } from 'date-fns';
import mbpLogger from 'mbp-logger';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';
import getDeliveryCalendarByProduct from '../../../../../apis/product-apis/getDeliveryCalendarByProduct';
import DeliveryCalendarButtonContainer from './DeliveryCalendarButtonContainer';
import GraphqlCalendarContainer from './GraphqlPDPCalendar/GraphqlCalendarContainer';
import GraphqlPortalLoader from '../../GraphqlCommonComponents/GraphqlPortalLoader';
import ConnectedProductAgeVerificationModal from './ProductAgeVerificationModal';
import GraphqlProductNotAvailableModal from './GraphqlProductNotAvailableModal';
import OneClickPaymentBuilder from './OneClickPayments/OneClickPaymentBuilder';
import CountryRestrictionModal from './CountryRestrictionModal';
import { actions as tagManagerActions } from '../../../../../state/ducks/TagManager';
import { getCountryDetailsByTwoDigitCountryCode } from '../../../../../state/ducks/Checkout/helpers/countryCode';
import { checkDateHasBackUpProduct } from '../../../../helpers/checkFptGptProductBackUp';
import PersonalizationModal from './PersonalizationModal';
import customBreakpoints from '../../../../helpers/customBreakpoints';
import GraphqlPDPGiftMessageBox from './GraphqlPDPGiftMessage';

import findProductPageByPartNumber from '../../../../gql/queries/findProductPageByPartNumber';
import {
    setLocationType,
    validateProductFilterZipcode,
    clearValidatedZipcode,
    resetProductFilterZipcodeValidity,
    setUserSubmittedProductFilterZipcode,
    clearUserSubmittedProductFilterZipcode,
    clearUserSelectedAddress,
    setUserSelectedAddress,
    setProductFilterZipcodeValidity,
    setValidatedZipcode,
    verifyWine,
} from '../../../../../state/ducks/App/App-Actions';
import {
    getLocationType,
    getValidatedZipcode,
    getIsProductFilterZipcodeValid,
    getUserSubmittedProductFilterZipcode,
    getSavedAddress,
    getWineData,
    getCountryData,
    getDataDictionary,
} from '../../../../../state/ducks/App/App-Selectors';
import memberDucks from '../../../../../state/ducks/Member/ducks';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { ducks as checkoutDucks } from '../../../../../state/ducks/Checkout';
import { getIsAuthenticatedStatus } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getZipByAddressSource } from '../../../../../state/ducks/Checkout/helpers/preCheckoutAddressNormalizer';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import DesktopMobile from '../../../../helpers/DesktopMobile/DesktopMobile';
import { getLanguageName, getCurrencyName } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const {
    checkout: { checkoutActions },
    cart: {
        cartDucks,
    },
    common: {
        commonSelectors: {
            getRecipientForm,
            getCartData,
        },
    },
    recipient: {
        recipientDucks: {
            recipientForm: {
                recipientFormActions,
            },
        },
    },
} = checkoutDucks;

const {
    common: {
        commonSelectors: {
            getAccessToken,
            getAddressBookEntries,
            getAddressBookPageNumber,
            getTotalNoOfPages,
            getTotalEntriesAddressBook,
            getUserType,
        },
    },
    addressBook: {
        addressBookActions: {
            loadAddressBook,
            removeAddressBook,
        },
    },
} = memberDucks;

const { deleteItemActions } = cartDucks.deleteItem;

const ENTER_KEY = 13;

const styles = (theme) => ({
    root: {
        marginBottom: '20px',
        width: '100%',
        color: theme?.palette?.common?.black,
        [theme.breakpoints.up('600')]: {
            border: `1px solid ${theme.palette?.pdp?.cardBorder}`,
        },
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
            marginBottom: 0,
        },
    },
    formContainer: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            marginTop: '15px',
            marginBottom: '20px',
        },
    },
    formWrapper: {
        position: 'relative',
        width: '50%',
        '&:after': {
            content: '""',
            position: 'absolute',
            top: '18px',
            right: '4px',
            width: '1px',
            height: '45px',
            borderLeft: `1px solid ${theme.palette?.pdp?.cardBorder}`, // Todo: add greys to brand palette
            [theme.breakpoints.down('sm')]: {
                top: '5px',
            },
        },
    },
    deliveryDestination: {
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        '&> div:first-child': {
            fontSize: '15px',
            opacity: 0.9,
            [theme.breakpoints.down('sm')]: {
                paddingBottom: '8px',
            },
        },
        cardmessage: {
            paddingBottom: 0,
        },
    },
    deliveryNote: {
        display: 'inline-block',
        fontSize: '12px',
        fontWeight: '400',
        paddingLeft: '10px',
        lineHeight: '1.5em',
        textTransform: 'none',
        letterSpacing: '0.3px',
        color: theme.palette.common?.black,
        opacity: 0.9,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
        },
    },
    zipCodeInput: {
        width: '100%',
        background: 'none',
        display: 'block',  // IE 11
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
        '& > div': {
            width: '100%', // IE 11
            paddingBottom: '5px',
            '& input': {
                fontSize: '17px',
            },
        },
        '& > label': {
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: 16,
            },
        },
    },
    zipCodeInputValid: {
        '& label::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.colorSuccess,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            fontSize: '9px',
            fontWeight: 'bold',
            lineHeight: '17px',
            right: '-20px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    zipCodeInputInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: 'white',
            lineHeight: '25px',
            fontSize: '11px',
            fontWeight: '300',
            content: '"Invalid zip code"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: 'calc(100% - 8px)',
            height: '25px',
            backgroundColor: 'red',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    locationWrapper: {
        width: '50%',
        marginTop: '14.5px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },

    },
    locationTypeLabel: {
        display: 'block',
        width: '100%',
        fontSize: '18px',
        paddingLeft: '5px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        },
    },
    locationTypeSelector: {
        width: '100%',
        fontSize: '17px',
        lineHeight: '17px',
        paddingLeft: '5px',
        '&> div': {
            paddingBottom: '11px',
            [theme.breakpoints.down('sm')]: {
                paddingBottom: '12px',
            },
        },
        '& svg': {
            color: theme.palette?.pdp?.cardBorder,
        },
    },
    paperHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        width: '100%',
        padding: '12px 15px',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '19px',
        color: theme.palette.colorPrimary,
        background: theme.palette.common?.lightPurple,
        borderRadius: '4px 4px 0 0',
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            padding: '12px 20px',
        },
    },
    paperHeaderLink: {
        color: '#5F3C86',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    paperBody: {
        boxSizing: 'border-box',
        padding: '13px 20px 10px 12px',
        [theme.breakpoints.down('sm')]: {
            padding: '10px 20px 10px 20px',
        },
    },
    buttonCalendarInvalidZip: {
        background: 'grey',
    },
    buttonDivider: {
        margin: '10px 0',
        width: '100%',
        textAlign: 'center',
    },
    buttonBuyNow: {
        width: '100%',
        height: '40px',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px',
        background: '#000',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    buttonAddToCart: {
        marginTop: '5px',
        width: '100%',
        height: '40px',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px',
        background: '#2ac670',
        borderRadius: '4px',
        cursor: 'pointer',
    },
});

const isCandaZip = (zipcode) => new RegExp(/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/).test(zipcode);

const getNow = (todayOrTom) => {
    const d = new Date();
    if (todayOrTom === 'tomorrow') {
        const newDate = d.getDate() + 1;
        d.setDate(newDate);
        d.setHours(0, 0, 0, 0);
        return d;
    }
    d.setHours(0, 0, 0, 0);
    return d;
}; // 12:00 midnight of current day

export class GraphqlAddToCartContainerUI extends Component {
    constructor(props) {
        super(props);
        const { userSubmittedZip } = this.props;
        this.state = {
            zipField: userSubmittedZip,
            showCalendar: false,
            showAgeVerification: false,
            calendarIsLoading: false,
            deliveryAvailable: true,
            signinIsLoading: false,
            ageDetails: {
                birthDay: '0',
                birthMonth: '0',
                birthYear: '0',
                minAge: '0',
            },
            todayTomArray: [],
            startDateString: '',
            todayTomDateNotAvailText: '',
            personalization: {
                modalOpen: false,
            },
            fireCalendarQuery: false,
            countryRestriction: false,
            retailPriceObj: {},
        };
        this.zipFieldRef = React.createRef();
    }

    componentDidMount() {
        const {
            zipValid, resetFilterZipcodeValidity, callLoadAddressBook, userType, selectedSku,
        } = this.props;
        if (zipValid === false) {
            resetFilterZipcodeValidity();
        }
        if (userType === 'R') {
            callLoadAddressBook();
        }
        // retailPriceObj for multicurrency
        const currentCurrency = getCurrencyName();
        const retailPriceObj = {
            [currentCurrency]: selectedSku?.prices?.[0]?.value,
        };
        this.setState({
            retailPriceObj,
        });
    }

    componentDidUpdate(prevProps) {
        const { userType, callLoadAddressBook, wineValidation } = this.props;
        const { showCalendar, showAgeVerification } = this.state;
        // const { signinIsLoading } = this.state;
        if (prevProps.userType !== userType && userType !== 'G') {
            callLoadAddressBook();
        }
        // stop loading once pdp sign-in is complete
        if (prevProps.userType === 'G' && userType === 'R') {
            this.setState({ signinIsLoading: false });
        }

        if (!showCalendar && showAgeVerification && this.getAvailability(wineValidation)) {
            this.showCalendar();
        }
    }

    // this method is refactored to use global stack country finder in the redux store
    getInternationalCountry = () => {
        const { countryData } = this.props;
        let countryCode = '';
        const country = window?.location?.pathname.split('/')[2] || '';
        for (let i = 0; i < countryData.length; i += 1) {
            if (countryData[i]?.iso_code_2 === country.toUpperCase()) {
                countryCode = countryData[i]?.iso_code_3?.split(' ')[0];
            }
        }
        return countryCode;
    }

    handleDeliveryAvailability = (boolean) => {
        this.setState({ deliveryAvailable: boolean });
    };

    handleCalendarModal = () => {
        const { productSkus } = this.props;
        if (productSkus[0].ageVerifyFlag === 'true') {
            this.setState({ showCalendar: false, showAgeVerification: true });
        } else {
            this.setState({ showCalendar: true });
        }
    };

    showCalendar = () => {
        const { showAgeVerification } = this.state;
        if (showAgeVerification) {
            this.handleAgeVerificationClose();
        }
        this.setState({ showCalendar: true, calendarIsLoading: true });
    }

    closeCalendar = () => {
        this.setState({
            showCalendar: false,
            calendarIsLoading: false,
            todayTomDateNotAvailText: '', // remove today/tomorrow availability message
        });
    };

    handleLocationTypeChange = (e) => {
        const { setLocation } = this.props;
        const location = e.target.value;
        // translate always to english, because the locationType is required in API calls for the delivery calendar
        const locationTranslations = {
            // fr
            Résidence: 'Residence',
            Entreprise: 'Business',
            'Maison funéraire': 'Funeral home',
            Hôpital: 'Hospital',
            Appartement: 'Apartment',
            École: 'School',
            Église: 'Church',
            // es
            Residencia: 'Residence',
            Negocio: 'Business',
            'Casa funeraria': 'Funeral home',
            Hospital: 'Hospital',
            Apartamento: 'Apartment',
            Colegio: 'School',
            Iglesia: 'Church',
        };
        if (getLanguageName() !== '/en') {
            setLocation(locationTranslations[location]);
        } else {
            setLocation(location);
        }
    };

    calendarButtonNoZip = () => {
        this.zipFieldRef.current.focus();
    };

    convertZipCode = (zipcode, preState) => {
        // handle zipcode conversion for canda
        if (preState.length < zipcode.length
            && zipcode.length >= 6
            && isCandaZip(zipcode)) {
            const zipSplit = zipcode.replace(/\s/gi, '').toUpperCase().split('');
            zipSplit.splice(3, 0, ' ');
            return zipSplit.join('');
        }
        return zipcode;
    }

    handleZipChange = (e) => {
        let zipCode = e.target.value?.replace?.(/[^a-zA-Z0-9\s]/g, '');
        const { zipField } = this.state;
        if (isCandaZip(zipCode)) {
            zipCode = this.convertZipCode(zipCode, zipField);
        }
        this.setState(
            {
                zipField: zipCode,
            },
            this.validateZip,
        );
    };

    handleZipFieldKeyPress = (event) => {
        if ((event.which && event.which === ENTER_KEY) || (event.keyCode && event.keyCode === ENTER_KEY)) {
            event.preventDefault();
            this.fullCalendarCall();
        }
    };

    setCalendarDataLoadingFlag = (boolean) => {
        this.setState({ calendarIsLoading: boolean });
    };

    displayZipValidCSSCheck = () => {
        const { zipField } = this.state;
        const { zipValid, classes, userSubmittedZip } = this.props;
        if (
            (zipValid === true && zipField.length >= 5)
            || (userSubmittedZip !== '' && zipField === userSubmittedZip)
        ) {
            return `${classes.zipCodeInput} ${classes.zipCodeInputValid}`;
        }
        if (zipValid === false && zipField.length >= 5) {
            return `${classes.zipCodeInput} ${classes.zipCodeInputInvalid}`;
        }
        return `${classes.zipCodeInput}`;
    };

    validateZip = () => {
        // this function determines when to validate a zipcode that the user enters
        const { zipField } = this.state;
        const {
            valZip,
            clearValidatedZip,
            zipValid,
            resetZipValidity,
            validatedZip,
            clearFilterZip,
            userSubmittedZip,
        } = this.props;
        if (zipField.length >= 5) {
            // if user enters five chars check if valid zip
            valZip(zipField);
        } else if (zipField.length < 5 && validatedZip !== '') {
            // if there are fewer than 5 chars and there exists a zip in redux clear it
            // we do this so that if someone enters a zipcode, then deletes it the filtering goes away.
            clearValidatedZip();
        }
        if (zipField.length < 5 && userSubmittedZip !== '') {
            clearFilterZip();
        }
        if (zipField.length !== 5 && zipValid !== null) {
            // reset the zip is valid flag in redux if zip is not characters.
            resetZipValidity();
        }
    };

    submitUserSelectedZipcode = () => {
        const { zipField } = this.state;
        const {
            validatedZip,
            setFilterZip,
            userSubmittedZip,
            savedAddress,
            clearSavedAddress,
        } = this.props;
        if (validatedZip === zipField) {
            setFilterZip(zipField);
        }
        if (userSubmittedZip !== getZipByAddressSource(savedAddress)) {
            // if an address is saved in guided nav but then the user enters a new zipcode in PDP
            // this resets the saved address in redux so it does not incorrectly prefill the previously
            // selected address
            clearSavedAddress();
        }
    };

    handleProductNotAvailableClose = () => {
        this.setState({ deliveryAvailable: true, showCalendar: false });
    };

    handleAgeVerificationClose = () => {
        this.setState({ showAgeVerification: false });
    }

    /*
    * @description get the availability from API response
    * @param {object} data
    */
    getAvailability = (data) => {
        let availability = false;
        if (!data?.wineAvailability) {
            return false;
        }
        const keys = Object.keys(data.wineAvailability);
        keys.forEach((key) => {
            if (data.wineAvailability[key]?.isProductAvailable) {
                availability = true;
            }
        });
        return availability;
    }

    getAgeVerificationDetails = (birthDay, birthMonth, birthYear) => {
        const { zipField } = this.state;
        const {
            productSkus, partNumber, brandId, callVerifyWine,
        } = this.props;

        const { minAge } = productSkus[0];
        this.setState({
            ageDetails: {
                birthDay,
                birthMonth,
                birthYear,
                minAge,
            },
        });

        if (partNumber && zipField && birthMonth && birthYear && birthDay) {
            const wineData = {
                birthDay,
                birthMonth,
                birthYear,
                brandCode: brandId,
                minAge,
                skuPartNumber: partNumber,
                zipCodes: [zipField],
            };
            callVerifyWine(wineData);
        }
    }

    addTodayOrTomToCart = (todayOrTom) => {
        const {
            validatedZip, userSubmittedZip, trackEvent, location,
        } = this.props;
        const { zipField } = this.state;
        if (!this.handleMultipleCountriesRestriction()) {
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Product Page',
                eventAction: 'Purchasing Option',
                eventLabel: (location.pathname.includes('subscription')) ? 'Subscription' : 'One Time',
            });
            if ((validatedZip !== '' && validatedZip === zipField) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) {
                trackEvent({
                    eventName: 'feature_interaction',
                    eventCategory: 'Product Page',
                    eventAction: 'Delivery Option Selected',
                    eventLabel: todayOrTom,
                });
                this.submitUserSelectedZipcode();
                this.getCalendarFromAPI(todayOrTom, '');
            } else {
                this.calendarButtonNoZip();
            }
        }
    }

    checkIfDateExsist = () => {
        const { todayTomArray, startDateString, retailPriceObj } = this.state;
        const {
            actionAddToCart,
            selectedSku,
            brand,
            history,
            locationType,
            location,
            productDeliveryType,
            userSubmittedZip,
            partNumber,
            sympathyValue,
            isPassportBundleItem,
            movieSelected,
            hasWine,
            wineValidation,
        } = this.props;

        let categoryId = null;
        let categoryName = null;
        let categoryPath = null;
        // if the user direct loads a product page there will be no categoryId
        if (location) {
            categoryPath = location.pathname;

            if (location.state) {
                const { fromCategoryPage } = location.state;

                if (fromCategoryPage) {
                    if (location.state.categoryId) {
                        categoryId = location.state.categoryId;
                    }

                    if (location.state.categoryPath) {
                        categoryPath = location.state.categoryPath;
                    }

                    if (location.state.categoryName) {
                        categoryName = location.state.categoryName;
                    }
                }
            }
        } else {
            categoryId = null;
        }

        let skipAddons = false;

        // sympathyValue: '1' - Home, '2' - Funeral
        if ((location.state && location.state.skipAddons) || (sympathyValue === '1' || sympathyValue === '2')) {
            skipAddons = true;
        }

        const attributes = [];
        // Attr: categoryId
        if (categoryId) {
            attributes.push({
                attributeName: 'categoryId',
                attributeValue: categoryId,
            });
        }

        // Attr: categoryIdent
        if (categoryName) {
            attributes.push({
                attributeName: 'categoryIdent',
                attributeValue: categoryName,
            });
        }

        // Attr: categoryPath
        if (categoryPath) {
            attributes.push({
                attributeName: 'categoryPath',
                attributeValue: categoryPath,
            });
        }

        // checking whether there is a start date in the todayTomArray
        const deliveryDates = (Array.isArray(todayTomArray) && startDateString) ? todayTomArray.filter((item) => item.deliveryDate === startDateString) : [];
        // isDeliveryAvailable will return a boolean data type
        const isDeliveryAvailable = !!(startDateString && deliveryDates.length); // true | false
        // If the product is availabe for today/tomorrow delivery
        if (isDeliveryAvailable) {
            const {
                backupSkuBrand: backUpProductBrandCode,
                backupSkuCode: backUpProductSkuCode,
                calendarDateType,
                deliveryDate,
                deliverySLA,
            } = deliveryDates[0];
            // We're using 1-800-flowers brand.id for .CA site;
            // other brands will use their own brand.id for adding item to cart
            const brandCode = brand.code === 'CAN' ? '1001' : brand.id;
            let productCode = selectedSku.id;
            let productPartNumber = partNumber;

            /* Feature - FPT / GPT - Back Up Product - Start */

            const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

            if (backUpProduct.hasProduct) {
                productCode = backUpProduct.productCode;
                productPartNumber = backUpProduct.productCode;
            }

            /* Feature - FPT / GPT - Back Up Product - End */
            const item = {
                brandCode,
                productCode,
                quantity: 1,
                delivery: {
                    calendarDateType,
                    deliveryDate,
                    zipCode: userSubmittedZip,
                    locationType,
                    deliverySLA,
                },
                attributes,
            };

            /* Wine data - Start */
            if (hasWine && wineValidation && this.getAvailability(wineValidation) && wineValidation.wineVerify) {
                item.wineVerify = wineValidation.wineVerify;
            }
            /* Wine data - End */
            actionAddToCart(
                item,
                history,
                productDeliveryType, // FPT or GPT
                categoryId,
                productPartNumber,
                skipAddons,
                deliveryDate,
                categoryName,
                categoryPath,
                isPassportBundleItem,
                movieSelected,
                {},
                {},
                retailPriceObj,
            );
        } else {
            // If the product isn't available for today/tomorrow delivery, we'll trigger the full calendar and inform users with the message bellow
            this.setState({
                todayTomDateNotAvailText: 'Today or tomorrow is no longer available for this zip. Please select a new date',
            });
            this.submitUserSelectedZipcode();
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(
                true,
            );
            // Trigger full calendar for users to choose other delivery date instead of today/tomorrow
            this.fullCalendarCall();
        }
    }

    generateTodayTomState = (todayTomCalendarDates, startDate) => {
        this.setState({
            todayTomArray: todayTomCalendarDates,
            startDateString: startDate,
        },
        () => { this.checkIfDateExsist(); });
    }

    isInternationalProduct = () => {
        const { productSkus } = this.props;
        if (typeof productSkus?.[0]?.isInternational !== 'undefined') {
            return productSkus[0].isInternational || false;
        }
        return false;
    }

    simpleAddToCart = (returnObject = false) => {
        // this add to cart is used when an 18F user views a product for a brand that does
        // not display delivery calendar on pdp
        const {
            foodAddToCart, selectedSku, brandId, history, partNumber, categoryId, categoryName, categoryPath,
        } = this.props;
        const { retailPriceObj } = this.state;

        const reqObj = {
            brandCode: brandId,
            productCode: selectedSku.id,
            quantity: 1,
            attributes: [],
        };
        if (returnObject) {
            return {
                reqObj,
                history,
                partNumber,
                categoryId,
                categoryName,
                categoryPath,
            };
        }
        foodAddToCart(reqObj, history, null, null, null, null, false, () => {}, null, false, {}, retailPriceObj);
        return null;
    }

    getCalendarFromAPI = (todayOrTom) => {
        const startDate = format(getNow(todayOrTom), 'yyyy-MM-dd');

        const {
            locationType,
            validatedZip,
            jwt,
            selectedSku,
        } = this.props;

        // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
        const itemSku = selectedSku.id.match(/[^-_]*$/);
        const brandId = selectedSku.brandId;

        getDeliveryCalendarByProduct(
            {},
            jwt,
            itemSku,
            brandId,
            validatedZip,
            locationType || 'Residence',
            startDate,
        )
            .then(({ data }) => {
                if (data.response.calendarDates.length === 0) {
                    this.submitUserSelectedZipcode();
                    this.handleDeliveryAvailability(false);
                    return;
                }
                const todayTomCalendarDates = data.response.calendarDates.filter((d, i) => (i < 3));

                this.generateTodayTomState(todayTomCalendarDates, startDate);
            })
            .catch((err) => {
                this.handleDeliveryAvailability(false);
                mbpLogger.logError({
                    component: 'GraphqlPDPCalendar',
                    apiCall: 'getDeliveryCalendarByProduct',
                    jsError: err,
                    jwt,
                    itemSku,
                    brandId,
                    validatedZip,
                    locationType,
                    startDate,
                });
            });
    };

    handleAgeVerify = (handleMobileAgeVerification, hasWine) => {
        const { displayDeliveryCalendar } = this.props;

        if (!this.handleMultipleCountriesRestriction()) {
            if (hasWine && !displayDeliveryCalendar) {
                handleMobileAgeVerification(true, this.fullCalendarCall(true));
            } else {
                this.fullCalendarCall();
            }
        }
    };

    handleMultipleCountriesRestriction = () => {
        const {
            selectedSku, cartDetails, history, brand,
        } = this.props;

        if (cartDetails && cartDetails?.orderDetails?.fdOrderVO?.orderSize && cartDetails?.orderDetails?.fdOrderVO?.status === 'P') {
            // cart is not empty and the status is pending.
            const countriesArray = selectedSku.countries;
            if (countriesArray && Array.isArray(countriesArray) && countriesArray.length) {
                let productCountry = '';
                const pathUrl = history.location?.pathname || '/';
                if (pathUrl !== '/' && brand?.code !== 'CAN') { // canada condition as we are not showing country code in url
                    const countryDetails = getCountryDetailsByTwoDigitCountryCode(pathUrl.split('/')[2].toUpperCase());
                    productCountry = countryDetails.countryCodeThreeDigit || '';
                } else {
                    productCountry = countriesArray[0];
                }
                const cartCountries = new Set();
                // cartItems
                const recipients = cartDetails.orderDetails?.fdOrderVO?.recipients;
                if (recipients && Array.isArray(recipients) && recipients.length) {
                    recipients.forEach(
                        (recipient) => {
                            const orderItems = recipient.orderItems;
                            if (orderItems && Array.isArray(orderItems) && orderItems.length) {
                                orderItems.forEach(
                                    (orderItem) => {
                                        if (orderItem.zipCode === '00000') {
                                            // is international
                                            cartCountries.add(orderItem.xOrderAttrValues?.internationalCountryCode);
                                        } else {
                                            // check the zip code to know if the item is from canada or usa
                                            const zipCode = orderItem.zipCode;
                                            const onlyNumbersRegex = new RegExp('^[0-9]+$');

                                            const isFromUSA = onlyNumbersRegex.test(zipCode);

                                            if (isFromUSA) {
                                                cartCountries.add('USA');
                                            } else {
                                                cartCountries.add('CAN');
                                            }
                                        }
                                    },
                                );
                            }
                        },
                    );
                }
                if (cartCountries?.size && !cartCountries.has(productCountry) && brand?.code === '08F') {
                    // is a different country from the ones that are in the cart
                    this.setState({ countryRestriction: true });
                    return true;
                }
            }
        }
        this.setState({ countryRestriction: false });
        return false;
    }

    handleEmptyCart = () => {
        const {
            cartDetails, deleteItemActions: deleteItemActionsRemoveItem,
        } = this.props;
        if (cartDetails) {
            const recipient = cartDetails.orderDetails?.fdOrderVO?.recipients?.[0] || null;
            const orderItem = recipient?.orderItems?.[0] || null;
            deleteItemActionsRemoveItem.deleteItem(orderItem.orderItemsId, false, null, 'cart', null, orderItem.catalogEntryVO?.skuCode, orderItem.catalogEntryVO?.parentSkuCode, true);
            this.setState({ countryRestriction: false });
        }
    }

    handleCountriesRestrictionClose= () => {
        this.setState({ countryRestriction: false });
    }

    fullCalendarCall = (returnObject = false) => {
        const {
            validatedZip, userSubmittedZip, trackEvent, selectedSku, displayDeliveryCalendar, location,
        } = this.props;
        const { zipField } = this.state;
        this.setState({ fireCalendarQuery: true });
        let returnVal = null;
        if (!displayDeliveryCalendar) {
            if (returnObject) {
                returnVal = this.simpleAddToCart(true);
                return returnVal;
            }
            this.simpleAddToCart();
            return returnVal;
        }
        trackEvent({
            eventName: 'feature_interaction',
            eventCategory: 'Product Page',
            eventAction: 'Purchasing Option',
            eventLabel: (location.pathname.includes('subscription')) ? 'Subscription' : 'One Time',
        });
        if (this.isInternationalProduct()) {
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Product Page',
                eventAction: 'Delivery Option Selected',
                eventLabel: 'More Dates',
            });
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(true);
        } else if ((validatedZip !== '' && validatedZip === zipField) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) {
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Product Page',
                eventAction: 'Delivery Option Selected',
                eventLabel: 'More Dates',
            });
            this.submitUserSelectedZipcode();
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                this.setState({ personalization: { modalOpen: true } });
                return returnVal;
            }
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(true);
        } else {
            this.calendarButtonNoZip();
        }
        return returnVal;
    };

    handlePersonalizationTextFieldChange = (e) => {
        const { personalization } = this.state;
        const stateCopy = personalization;
        if (e.target.value.length < stateCopy.lineState[Number(e.target.name)].maxChars) {
            stateCopy.lineState[e.target.name].lineText = e.target.value;
        }
        this.setState({
            personalization: stateCopy,
        });
    }

    handlePersonalizationModalSubmit = () => {
        const { personalization } = this.state;
        const newPersonalizationState = { ...personalization, modalOpen: false };
        this.setState({
            personalization: newPersonalizationState,
            calendarIsLoading: true,
        });
        this.handleCalendarModal();
    }

    setPersonalizationState = (newState) => {
        this.setState({
            personalization: newState,
        });
    }

    closePersonalizationModal = () => {
        this.setState({
            personalization: { modalOpen: false },
        });
    }

    // had to add from DeliveryForm.js
    handleRemoveAddressBook = (addressBookEntryId) => {
        const {
            userType,
            callRemoveAddressBook,
        } = this.props;
        if (userType === 'R' && addressBookEntryId) {
            callRemoveAddressBook(addressBookEntryId);
        }
    }

    handleSelectedAddressBook  = (data) => {
        const {
            setLocation, setFilterZip, setSelectedAddress, userSubmittedZip, clearFilterZip, setZipcodeValidity, setValZip,
        } = this.props;
        if (userSubmittedZip) {
            clearFilterZip();
        }
        const addressComponents = data?.Addresses[0] || {};
        const postalCode = (addressComponents.PostalCode) ? addressComponents.PostalCode.split('-')[0] : '';

        setLocation(addressComponents?.AddressType || 'Residence');
        addressComponents.EmployerName = data?.EmployerName || '';
        addressComponents.FirstName = data?.FirstName || '';
        addressComponents.LastName = data?.LastName || '';
        if (data?.PhoneNumber) {
            addressComponents.PhoneNumber = data.PhoneNumber;
        }
        this.setState({
            zipField: postalCode,
        }, () => {
            setValZip(postalCode);
            setZipcodeValidity(true);
            return setFilterZip(postalCode);
        });
        const reduxAddress = {
            addressComponents,
            addressSource: 'pdpAddressBook',
        };
        setSelectedAddress(reduxAddress);
    }

    renderQueryByCurrency = (currency) => {
        const { brand, partNumber, selectedSku } = this.props;
        const { retailPriceObj } = this.state;
        const FIND_PRODUCT_PAGE_BY_PARTNUMBER = findProductPageByPartNumber(brand.domain, partNumber, currency);
        if (retailPriceObj[currency] === undefined) {
            return (
                <Query query={FIND_PRODUCT_PAGE_BY_PARTNUMBER}>
                    {
                        ({ loading, error, data }) => {
                            if (loading) return null;
                            if (error) {
                                mbpLogger.logError({
                                    jsError: error,
                                    message: `Failed to fetch data for: ${FIND_PRODUCT_PAGE_BY_PARTNUMBER} on brand ${brand} on component GraphqlPDPCalendar`,
                                });
                            }

                            const product = data?.findProductPageByPartNumber?.product || null;
                            if (product) {
                                if (Array.isArray(product.productSkus) && product.productSkus.length) {
                                    const copySelectedSku = product.productSkus.find((sku) => sku.id === selectedSku?.id);
                                    if (copySelectedSku) {
                                        const newRetailPriceObj = { ...retailPriceObj, [currency]: copySelectedSku.prices?.[0]?.value };
                                        this.setState({
                                            retailPriceObj: newRetailPriceObj,
                                        });
                                    }
                                }
                                return true;
                            }
                            return null;
                        }
                    }
                </Query>
            );
        }
        return null;
    };

    availableCurrencies = () => {
        const { brand } = this.props;
        const currentCurrency = getCurrencyName();
        let currenciesArray = ['USD'];
        if (brand.code === 'CAN') {
            currenciesArray = [currentCurrency];
            return currenciesArray;
        }
        return currenciesArray.filter((item) => item !== currentCurrency);
    };

    render() {
        const {
            showCalendar,
            showAgeVerification,
            calendarIsLoading,
            deliveryAvailable,
            ageDetails,
            todayTomDateNotAvailText,
            zipField,
            signinIsLoading,
            personalization,
            fireCalendarQuery,
            countryRestriction,
        } = this.state;
        const {
            classes,
            config: {
                show_optional_gift_message,
            },
            locationType,
            userSubmittedZip,
            selectedSku,
            zipValid,
            productDeliveryType,
            brandId,
            deliveryData,
            partNumber,
            sympathyValue,
            productName,
            trackEvent,
            featureFlags,
            isPassportBundleItem,
            validatedZip,
            displayDeliveryCalendar,
            movieSelected,
            handleMobileAgeVerification,
            hasWine,
            isPassportBundleProduct,
            brand,
            dataDictionary,
        } = this.props;
        const isInternationalProduct = this.isInternationalProduct();
        const internationalCountry = this.getInternationalCountry();
        const locationTypeOptions = deliveryData.location_type_options || [];
        const deliveryTitle = isInternationalProduct ? 'Choose a Delivery Date' : 'Enter Delivery Destination';
        const checkCalenderSection = () => {
            // Return true if Brand 0800 and International product
            if (isInternationalProduct && brand?.code === '08F') {
                return true;
            }
            // Return true if Brand Canada and non International Product
            if (!isInternationalProduct && brand?.code !== '08F') {
                return true;
            }
            return false;
        };
        const language = getLanguageName();
        const deliveryNote = 'Please Note: We currently deliver one product per country per transaction';
        const availableCurrencies = this.availableCurrencies();

        return (
            <div>
                {/* logic to support multicurrency in the retailPrice (stored in redux (ui -> currentProduct -> retailPrice) for checkout flow) */}
                {availableCurrencies.map((item) => this.renderQueryByCurrency(item))}
                <GraphqlProductNotAvailableModal isOpen={!deliveryAvailable && userSubmittedZip !== ''} onClose={this.handleProductNotAvailableClose} productName={productName} deliveryAvailable={deliveryAvailable} trackEvent={trackEvent} hideCta />
                <CountryRestrictionModal
                    isOpen={countryRestriction}
                    onClose={this.handleCountriesRestrictionClose}
                    emptyCart={this.handleEmptyCart}
                    dataDictionary={dataDictionary}
                />
                {calendarIsLoading && !(!deliveryAvailable && userSubmittedZip !== '') ? <GraphqlPortalLoader /> : null}
                {signinIsLoading ? <GraphqlPortalLoader /> : null}
                {selectedSku.personalization?.lines && <PersonalizationModal isOpen={personalization.modalOpen} personalization={selectedSku.personalization} setPersonalizationState={this.setPersonalizationState} personalizationState={personalization} handlePersonalizationTextFieldChange={this.handlePersonalizationTextFieldChange} handlePersonalizationModalSubmit={this.handlePersonalizationModalSubmit} closePersonalizationModal={this.closePersonalizationModal} /> }
                <Paper elevation={1} className={classes.root}>
                    <div className={displayDeliveryCalendar ? classes.paperHeader : null}>
                        {displayDeliveryCalendar && <div className={classes.deliveryDestination}><div>2. {language === '/en' ? deliveryTitle : dataDictionary[deliveryTitle]}</div> <div className={classes.deliveryNote}>{language === '/en' ? `${deliveryNote}.` : `${dataDictionary[deliveryNote]}`}</div></div>}
                    </div>
                    <div className={classes.paperBody}>
                        <form noValidate autoComplete="off">
                            { /* avoid displaying zipcode and location type fields for international products */ }
                            {!isInternationalProduct && displayDeliveryCalendar && (
                                <div className={classes.formContainer}>
                                    <div className={classes.formWrapper}>
                                        <DesktopMobile
                                            desktop={() => (
                                                <TextField
                                                    className={this.displayZipValidCSSCheck()}
                                                    margin="normal"
                                                    id="zipcode-text-field"
                                                    data-test="pdp-zipcode-text-field"
                                                    data-testid="pdp-zipcode-text-field"
                                                    name="zipcodeTextField"
                                                    label={
                                                        language === '/en'
                                                            ? deliveryData.zip_code_title : dataDictionary[deliveryData.zip_code_title]
                                                    }
                                                    onKeyPress={this.handleZipFieldKeyPress}
                                                    onChange={this.handleZipChange}
                                                    // defaultValue={userSubmittedZip}
                                                    value={zipField}
                                                    inputRef={this.zipFieldRef}
                                                    inputProps={{ maxLength: 7 }}
                                                />
                                            )}
                                            mobile={() => (
                                                <TextField
                                                    className={this.displayZipValidCSSCheck()}
                                                    margin="normal"
                                                    id="zipcode-text-field"
                                                    data-test="pdp-zipcode-text-field"
                                                    data-testid="pdp-zipcode-text-field"
                                                    name="zipcodeTextField"
                                                    label={
                                                        language === '/en'
                                                            ? deliveryData.zip_code_title : dataDictionary[deliveryData.zip_code_title]
                                                    }
                                                    onKeyPress={this.handleZipFieldKeyPress}
                                                    onChange={this.handleZipChange}
                                                    type="text"
                                                    value={zipField}
                                                    inputRef={this.zipFieldRef}
                                                    inputProps={{ maxLength: 7 }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className={classes.locationWrapper}>
                                        <InputLabel
                                            className={classes.locationTypeLabel}
                                            shrink
                                            htmlFor="alocation-type"
                                        >
                                            { language === '/en'
                                                ? deliveryData.location_type_title : dataDictionary[deliveryData.location_type_title]}
                                        </InputLabel>
                                        <Select
                                            className={classes.locationTypeSelector}
                                            inputProps={{
                                                name: 'location-type',
                                                id: 'location-type',
                                            }}
                                            name="Location Type"
                                            data-test="pdp-select-location"
                                            id="select-location-type"
                                            value={language === '/en' ? locationType : dataDictionary?.[locationType] || locationType}
                                            onChange={this.handleLocationTypeChange}
                                        >
                                            {locationTypeOptions.map((location) => {
                                                if (language === '/en') {
                                                    return (
                                                        <MenuItem
                                                            value={location.name}
                                                            key={location.name}
                                                        >
                                                            {location.name}
                                                        </MenuItem>
                                                    );
                                                }
                                                return (
                                                    <MenuItem
                                                        value={dataDictionary[location.name]}
                                                        key={location.name}
                                                    >
                                                        {dataDictionary[location.name]}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </div>
                                </div>
                            )}

                            {!isInternationalProduct && show_optional_gift_message && brand?.code !== '08F' && (
                                <GraphqlPDPGiftMessageBox />
                            )}

                            {isInternationalProduct && brand?.code === '08F' && show_optional_gift_message && (
                                <GraphqlPDPGiftMessageBox />
                            )}
                            {checkCalenderSection() && (
                                <div>
                                    <DeliveryCalendarButtonContainer
                                        addTodayOrTomToCart={this.addTodayOrTomToCart}
                                        fullCalendarCall={() => {
                                            this.handleAgeVerify(handleMobileAgeVerification, hasWine);
                                        }}
                                        zipValid={zipValid}
                                        productDeliveryType={productDeliveryType}
                                        isInternationalProduct={isInternationalProduct}
                                        todayTomorrowFlagEnabled={featureFlags && featureFlags['is-today-tomorrow-enabled']}
                                        displayDeliveryCalendar={displayDeliveryCalendar}
                                    />
                                    <OneClickPaymentBuilder selectedSku={selectedSku} movieSelected={movieSelected} />
                                    { fireCalendarQuery && (
                                        <GraphqlCalendarContainer
                                            close={this.closeCalendar}
                                            isOpen={showCalendar}
                                            selectedItemId={selectedSku?.id}
                                            selectedSku={selectedSku}
                                            productDeliveryType={productDeliveryType}
                                            productName={productName}
                                            brandId={brandId}
                                            ageDetails={ageDetails}
                                            setCalendarDataLoadingFlag={
                                                this.setCalendarDataLoadingFlag
                                            }
                                            handleDeliveryAvailability={
                                                this.handleDeliveryAvailability
                                            }
                                            partNumber={partNumber}
                                            todayTomDateNotAvailText={todayTomDateNotAvailText}
                                            sympathyValue={sympathyValue}
                                            isInternationalProduct={isInternationalProduct}
                                            internationalCountry={internationalCountry}
                                            isPassportBundleItem={isPassportBundleItem}
                                            validatedZip={validatedZip}
                                            personalization={personalization}
                                            movieSelected={movieSelected}
                                            isPassportBundleProduct={isPassportBundleProduct || {}}
                                            hasWine={selectedSku?.ageVerifyFlag}
                                        />
                                    )}
                                    { showAgeVerification
                                && (
                                    <ConnectedProductAgeVerificationModal
                                        isOpen={showAgeVerification}
                                        setCalendarDataLoadingFlag={
                                            this.setCalendarDataLoadingFlag
                                        }
                                        handleAgeVerificationClose={
                                            this.handleAgeVerificationClose
                                        }
                                        getAgeVerificationDetails={
                                            this.getAgeVerificationDetails
                                        }
                                    />
                                )}
                                </div>
                            )}
                        </form>
                    </div>
                </Paper>
                {(!isInternationalProduct && brand?.code === '08F') && (
                    <Paper elevation={2} className={classes.root}>
                        <div className={displayDeliveryCalendar ? classes.paperHeader : null}>
                            <div className={classes.deliveryDestination}><div className={classes.cardmessage}>{language === '/en' ? '3. ADD A CARD MESSAGE' : `3. ${dataDictionary['ADD A CARD MESSAGE']}`}</div> </div>
                        </div>
                        <div className={classes.paperBody}>
                            <form noValidate autoComplete="off">

                                {show_optional_gift_message && (
                                    <GraphqlPDPGiftMessageBox />
                                )}

                                <div>
                                    <DeliveryCalendarButtonContainer
                                        addTodayOrTomToCart={this.addTodayOrTomToCart}
                                        fullCalendarCall={() => {
                                            this.handleAgeVerify(handleMobileAgeVerification, hasWine);
                                        }}
                                        zipValid={zipValid}
                                        productDeliveryType={productDeliveryType}
                                        isInternationalProduct={isInternationalProduct}
                                        todayTomorrowFlagEnabled={featureFlags && featureFlags['is-today-tomorrow-enabled']}
                                        displayDeliveryCalendar={displayDeliveryCalendar}
                                        language={language}
                                    />
                                    <OneClickPaymentBuilder selectedSku={selectedSku} movieSelected={movieSelected} />
                                    { fireCalendarQuery && (
                                        <GraphqlCalendarContainer
                                            close={this.closeCalendar}
                                            isOpen={showCalendar}
                                            selectedItemId={selectedSku?.id}
                                            selectedSku={selectedSku}
                                            productDeliveryType={productDeliveryType}
                                            productName={productName}
                                            brandId={brandId}
                                            ageDetails={ageDetails}
                                            setCalendarDataLoadingFlag={
                                                this.setCalendarDataLoadingFlag
                                            }
                                            handleDeliveryAvailability={
                                                this.handleDeliveryAvailability
                                            }
                                            partNumber={partNumber}
                                            todayTomDateNotAvailText={todayTomDateNotAvailText}
                                            sympathyValue={sympathyValue}
                                            isInternationalProduct={isInternationalProduct}
                                            internationalCountry={internationalCountry}
                                            isPassportBundleItem={isPassportBundleItem}
                                            validatedZip={validatedZip}
                                            personalization={personalization}
                                            movieSelected={movieSelected}
                                            isPassportBundleProduct={isPassportBundleProduct || {}}
                                            hasWine={selectedSku?.ageVerifyFlag}
                                        />
                                    )}
                                    { showAgeVerification
                                && (
                                    <ConnectedProductAgeVerificationModal
                                        isOpen={showAgeVerification}
                                        setCalendarDataLoadingFlag={
                                            this.setCalendarDataLoadingFlag
                                        }
                                        handleAgeVerificationClose={
                                            this.handleAgeVerificationClose
                                        }
                                        getAgeVerificationDetails={
                                            this.getAgeVerificationDetails
                                        }
                                    />
                                )}
                                </div>
                            </form>
                        </div>
                    </Paper>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locationType: getLocationType(state),
    jwt: getAccessToken(state),
    brand: getBrand(state),
    validatedZip: getValidatedZipcode(state),
    zipValid: getIsProductFilterZipcodeValid(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    savedAddress: getSavedAddress(state),
    addressBookEntries: getAddressBookEntries(state),
    addressBookPageOn: getAddressBookPageNumber(state),
    addressBookTotalPages: getTotalNoOfPages(state),
    totalAddresses: getTotalEntriesAddressBook(state),
    userType: getUserType(state),
    fieldValue: getRecipientForm(state),
    featureFlags: getFeatureFlags(state),
    wineValidation: getWineData(state),
    cartDetails: getCartData(state),
    countryData: getCountryData(state),
    dataDictionary: getDataDictionary(state),
});

const mapDispatchToProps = (dispatch) => ({
    setLocation: bindActionCreators(setLocationType, dispatch),
    resetZipValidity: bindActionCreators(
        resetProductFilterZipcodeValidity,
        dispatch,
    ),
    setZipcodeValidity: bindActionCreators(setProductFilterZipcodeValidity, dispatch),
    valZip: bindActionCreators(validateProductFilterZipcode, dispatch),
    clearValidatedZip: bindActionCreators(clearValidatedZipcode, dispatch),
    setFilterZip: bindActionCreators(
        setUserSubmittedProductFilterZipcode,
        dispatch,
    ),
    setValZip: bindActionCreators(setValidatedZipcode, dispatch),
    clearFilterZip: bindActionCreators(clearUserSubmittedProductFilterZipcode, dispatch),
    resetFilterZipcodeValidity: bindActionCreators(resetProductFilterZipcodeValidity, dispatch),
    clearSavedAddress: bindActionCreators(clearUserSelectedAddress, dispatch),
    actionAddToCart: bindActionCreators(checkoutActions.addToCart, dispatch),
    foodAddToCart: bindActionCreators(checkoutActions.addToCartFood, dispatch),
    callLoadAddressBook: bindActionCreators(loadAddressBook, dispatch),
    callRemoveAddressBook: bindActionCreators(removeAddressBook, dispatch),
    recipientAction: bindActionCreators(recipientFormActions, dispatch),
    setSelectedAddress: bindActionCreators(setUserSelectedAddress, dispatch),
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    callVerifyWine: bindActionCreators(verifyWine, dispatch),
    deleteItemActions: bindActionCreators(deleteItemActions, dispatch),
});

GraphqlAddToCartContainerUI.propTypes = {
    classes: object.isRequired,
    locationType: string.isRequired,
    validatedZip: string.isRequired,
    zipValid: bool,
    setLocation: func.isRequired,
    resetZipValidity: func.isRequired,
    jwt: string.isRequired,
    brand: object.isRequired,
    valZip: func.isRequired,
    clearValidatedZip: func.isRequired,
    userSubmittedZip: string.isRequired,
    setValZip: func.isRequired,
    selectedSku: shape({
        __typename: string.isRequired,
        id: string.isRequired,
        name: string.isRequired,
    }),
    setFilterZip: func.isRequired,
    productDeliveryType: string.isRequired,
    productSkus: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            ageVerifyFlag: string.isRequired,
            minAge: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                }),
            ),
            isInternational: bool.isRequired,
        }),
    ).isRequired,
    brandId: string.isRequired,
    deliveryData: shape({
        location_type_options: arrayOf(
            shape({
                name: string.isRequired,
                value: string,
            }),
        ),
        show: bool.isRequired,
        title: string.isRequired,
        zip_code_title: string.isRequired,
        location_type_title: string.isRequired,
    }).isRequired,
    clearFilterZip: func.isRequired,
    clearSavedAddress: func.isRequired,
    config: shape({
        show_optional_gift_message: bool.isRequired,
    }).isRequired,
    setZipcodeValidity: func.isRequired,
    savedAddress: shape({
        addressSource: string,
        addressComponents: arrayOf(
            shape({ // This shape is for addresses saved from google places. More will be added when aditional address sources are added
                long_name: string.isRequired,
                short_name: string.isRequired,
                types: arrayOf(
                    string,
                ).isRequired,
            }),
        ),
    }).isRequired,
    partNumber: string.isRequired,
    actionAddToCart: func.isRequired,
    history: object.isRequired,
    location: object.isRequired,
    resetFilterZipcodeValidity: func.isRequired,
    sympathyValue: string.isRequired,
    callLoadAddressBook: func.isRequired,
    userType: string.isRequired,
    callRemoveAddressBook: func.isRequired,
    setSelectedAddress: func.isRequired,
    trackEvent: func.isRequired,
    productName: string.isRequired,
    featureFlags: object.isRequired,
    isPassportBundleItem: bool.isRequired,
    displayDeliveryCalendar: bool.isRequired,
    foodAddToCart: func.isRequired,
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    isPassportBundleProduct: shape({
        prices: shape({
            value: number,
        }),
        enable: bool,
    }),
    categoryId: string,
    categoryPath: string,
    categoryName: string,
    handleMobileAgeVerification: func,
    hasWine: bool,
    callVerifyWine: func.isRequired,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
    cartDetails: shape({
        orderDetails: shape({
            fdOrderVO: shape({
                recipients: arrayOf(shape({
                    orderItems: arrayOf(shape({
                        zipCode: string,
                        xOrderAttrValues: shape({
                            categoryPath: string,
                            internationalCountryCode: string,
                        }),
                    })),
                })),
            }),
        }),
    }).isRequired,
    deleteItemActions: shape({
        deleteItem: func.isRequired,
    }).isRequired,
    countryData: shape({
        length: number.isRequired,
    }),
    dataDictionary: object.isRequired,
};

GraphqlAddToCartContainerUI.defaultProps = {
    zipValid: null,
    selectedSku: null,
    movieSelected: null,
    isPassportBundleProduct: {},
    categoryId: '',
    categoryPath: '',
    categoryName: '',
    handleMobileAgeVerification: () => { },
    hasWine: false,
    wineValidation: null,
    countryData: {},
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withStyles(styles)(GraphqlAddToCartContainerUI)),
);
